import React from 'react';
import PropTypes from 'prop-types';
import {
  FDEmptyState,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import ActionItemsHeader from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/TasksDialog/Dialog/ActionItemsHeader';
import ListItemContainerWrapper from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ListItemContainer';

export default function DialogContent({
  collection,
  showHidden,
  setShowHidden,
  refresh,
}) {
  const emptyState = (
    <FDEmptyState title={"You don't have any tasks at the moment"} />
  );

  if (!collection) {
    return emptyState;
  }

  return (
    <FDStack direction="column" spacing={3}>
      <ActionItemsHeader
        showHidden={showHidden}
        getTaskCollection={setShowHidden}
      />
      {collection.resources().list().map((group) => {
        return (
          <FDStack direction="column" spacing={1}>
            <FDTitleText value={group.attr('title')} />
            {group.attr('actionItems')?.resources()?.length() > 0
              ? group.attr('actionItems')?.resources().list().map((actionItem) => (
                <ListItemContainerWrapper resource={actionItem} replaceActionItem={refresh} refreshActionItems={refresh} />
              )) : emptyState}
          </FDStack>
        );
      })}
    </FDStack>
  );
}

DialogContent.defaultProps = {
};

DialogContent.propTypes = {
  collection: PropTypes.object.isRequired,
  showHidden: PropTypes.bool.isRequired,
  setShowHidden: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
};
